const getNumberFormatter = (locale: string) =>
  new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

export function formatPrice(price: number, locale: string = 'vi', currency: string = 'đ') {
  return `${getNumberFormatter(locale).format(price)} ${currency}`
}

export const formatPriceK = (price: number, locale: string = 'vi'): string => {
  // Convert to integer by removing decimal part
  const intPrice = Math.floor(price)

  // Handle millions
  if (intPrice >= 1000000) {
    const millions = intPrice / 1000000
    return `${millions.toFixed(millions % 1 === 0 ? 0 : 1)}M`
  }

  // Handle thousands
  if (intPrice >= 1000) {
    const thousands = intPrice / 1000
    return `${thousands.toFixed(thousands % 1 === 0 ? 0 : 1)}K`
  }

  // Format regular numbers
  return getNumberFormatter(locale).format(intPrice)
}
